/**
 * @typedef ChatState
 * @property {ChatRoom}                                 room        채팅방
 * @property {import("socket.io-client").Socket|null}   socket      소켓
 * @property {boolean}                                  loading     로딩
 */

/**
 * @param {ChatState} state
 * @returns {ChatState}
 */
export function initChatState(state = {}) {
    return {
        ...(state || {}),
        room: initChatRoom(state?.room),
        socket: state?.socket ?? null,
        loading: state?.loading || false,
    };
}

/**
 * @typedef ChatRoom
 *
 * @property {object}           owner               사용자
 * @property {string}           owner._user         사용자 인덱스
 * @property {string}           owner.sessionId     사용자 세션ID
 * @property {string}           owner.sessionName   사용자 세션이름
 *
 * @property {ChatMessage[]}    messages            메시지
 *
 * @property {boolean}          isClosed            종료여부
 *
 * @property {string}           createdAt           생성일시
 * @property {string}           updatedAt           갱신일시
 */

/**
 * @param {ChatRoom} room
 * @returns {ChatRoom}
 */

export function initChatRoom(room = {}) {
    return {
        ...(room || {}),

        messages: [...(room?.messages || [])].map(initChatMessage),
    };
}

/**
 * @typedef ChatMessage
 * @property {'PROMPT_ALERT'|'PROMPT_QUERY'|'PROMPT_REPLY'} type        유형
 * @property {string}                                       content     메시지
 * @property {string}                                       createdAt   생성일시
 * @property {string}                                       updatedAt   갱신일시
 */

/**
 * @param {ChatMessage} message
 * @returns {ChatMessage}
 */

export function initChatMessage(message = {}) {
    return {
        ...(message || {}),
    };
}
